import React from "react";

const RefundCancellation = () => {
  return (
    <div style={styles.container}>
      <h1 style={styles.heading}>Refund & Cancellation Policy</h1>

      <p style={styles.paragraph}>
        <strong>Headway Spot — Subscription, Billing & Refund Policy</strong>
        <br />
        Operated by <strong>Funde Technologies</strong>
      </p>

      <h2 style={styles.subheading}>1. Subscription Model</h2>
      <p style={styles.paragraph}>
        Headway Spot offers its SaaS platform through a Free Plan and Paid
        Subscription Plans (“Pro” and “Enterprise”). Paid plans are automated
        with recurring billing, based on the billing frequency selected at the
        time of purchase (monthly or yearly).
      </p>
      <p style={styles.paragraph}>
        Your subscription begins immediately once payment is successfully
        processed.
      </p>

      <h2 style={styles.subheading}>2. No Trial Period</h2>
      <p style={styles.paragraph}>
        Headway Spot does not offer a separate trial period. All users may use
        the Free Plan indefinitely and upgrade to a paid subscription at any
        time. Paid features become available instantly once payment is
        confirmed.
      </p>

      <h2 style={styles.subheading}>3. Billing & Renewals</h2>
      <ul style={styles.list}>
        <li>All paid plans are charged in advance</li>
        <li>
          Subscriptions renew automatically (monthly or yearly) based on the
          original purchase date
        </li>
        <li>Renewals continue until you cancel your subscription</li>
        <li>
          Payments are processed via approved partners (Razorpay / Zoho)
        </li>
      </ul>

      <h2 style={styles.subheading}>4. Cancellation Policy</h2>
      <p style={styles.paragraph}>
        You may cancel your paid subscription at any time by emailing:
      </p>
      <p style={styles.paragraph}>
        📩 <strong>subscriptions@headwayspot.com</strong>
      </p>

      <p style={styles.paragraph}>Upon successful cancellation:</p>
      <ul style={styles.list}>
        <li>You will receive an email confirmation</li>
        <li>
          Your account will revert to the Free Plan at the end of the current
          billing period
        </li>
        <li>
          Your projects, tasks, team structure, and workspace will remain
          intact unless data deletion is explicitly requested
        </li>
      </ul>

      <p style={styles.notice}>
        ❗ <strong>Important Notes</strong>
      </p>
      <ul style={styles.list}>
        <li>No refunds or credits for partial months or years</li>
        <li>
          If you cancel mid-cycle, your paid plan remains active until the end
          of the billing period
        </li>
        <li>
          Once account deletion is requested, all associated data is
          permanently deleted and cannot be recovered
        </li>
      </ul>

      <h2 style={styles.subheading}>5. Refund Policy</h2>
      <p style={styles.paragraph}>
        Headway Spot follows a strict <strong>No Refund</strong> policy.
      </p>
      <ul style={styles.list}>
        <li>No refunds for partial or unused subscription periods</li>
        <li>No refunds for failure to cancel before renewal</li>
        <li>No refunds for unused features</li>
        <li>No prorated refunds on downgrades</li>
        <li>All payments are final</li>
      </ul>

      <h2 style={styles.subheading}>6. Taxes</h2>
      <p style={styles.paragraph}>
        All subscription fees are exclusive of GST and applicable taxes. You
        are responsible for any taxes, duties, or levies applicable in your
        jurisdiction.
      </p>

      <h2 style={styles.subheading}>7. Upgrades & Downgrades</h2>
      <p style={styles.paragraph}>
        Subscription changes can be requested by emailing:
      </p>
      <p style={styles.paragraph}>
        📩 <strong>subscriptions@headwayspot.com</strong>
      </p>

      <h3 style={styles.minorHeading}>Upgrades</h3>
      <ul style={styles.list}>
        <li>
          The new plan amount will be charged starting from the next billing
          cycle
        </li>
        <li>
          Upgraded features become available immediately after payment
        </li>
      </ul>

      <h3 style={styles.minorHeading}>Downgrades</h3>
      <ul style={styles.list}>
        <li>Downgrades take effect on the next renewal date</li>
        <li>No refunds are provided during the active billing period</li>
      </ul>

      <h2 style={styles.subheading}>8. Refusal or Termination of Service</h2>
      <p style={styles.paragraph}>
        Headway Spot reserves the right to refuse or cancel subscriptions for
        any reason. No refunds will be issued for terminations due to:
      </p>
      <ul style={styles.list}>
        <li>Abuse of platform features</li>
        <li>Violation of Terms of Service</li>
        <li>Security risks</li>
        <li>Fraudulent activity</li>
        <li>
          Attempts to remove or misrepresent Headway Spot branding
        </li>
      </ul>

      <h2 style={styles.subheading}>9. Service Modifications</h2>
      <p style={styles.paragraph}>
        Funde Technologies may modify, discontinue, or terminate any part of
        the Headway Spot service at any time, with or without prior notice.
      </p>

      <h2 style={styles.subheading}>10. Applicability</h2>
      <p style={styles.paragraph}>
        This Subscription & Cancellation Policy applies to all SaaS services
        offered under the Headway Spot platform unless otherwise stated in
        product-specific documentation.
      </p>
    </div>
  );
};

const styles = {
  container: {
    maxWidth: "900px",
    margin: "0 auto",
    padding: "40px 20px",
    lineHeight: "1.7",
    color: "#1f2937",
  },
  heading: {
    fontSize: "32px",
    fontWeight: "700",
    marginBottom: "24px",
  },
  subheading: {
    fontSize: "20px",
    fontWeight: "600",
    marginTop: "28px",
    marginBottom: "12px",
  },
  minorHeading: {
    fontSize: "17px",
    fontWeight: "600",
    marginTop: "18px",
    marginBottom: "8px",
  },
  paragraph: {
    fontSize: "16px",
    marginBottom: "14px",
  },
  list: {
    paddingLeft: "20px",
    marginBottom: "16px",
  },
  notice: {
    fontSize: "16px",
    marginTop: "12px",
    marginBottom: "8px",
  },
};

export default RefundCancellation;